export const CUSTOM_TEMPLATE_TYPES = {
  checkbox: 'checkbox',
  openQuestion: 'open_question',
  service: 'service',
  selectBox: 'select_box',
}

export const MAX_OPTION_NAME_LENGTH = 20
export const MAX_DESCRIPTION_LENGTH = 30
